export default __webpack_public_path__ + "static/media/marker.ef013a58.png";